import React, { useEffect } from "react";
import Phone from "./items/phone";
import PostalAdress from "./items/postalAdress";
import Linkedin from "./items/linkedin";

const config = require("../../config.json")
const client = config.APP_CLIENT;
const imgName = config.APP_IMG_NAME;
const compagnyName = config.APP_COMPAGNY_NAME;
const compagnyColorPrimary = config.APP_COMPAGNYCOLORPRIMARY;
const compagnyColorSecondary = config.APP_COMPAGNYCOLORSECONDARY;
const colorBackgroundTable = config.APP_COLORBACKGROUNDTABLE;
const widthImage = config.APP_WIDTHIMAGE;

const WrapperStyle = {
  width: "570px",
  minWidth: "580px",
  maxWidth: "580px",
  whiteSpace: "nowrap",
};

const SignatureStyle = {
  borderSpacing: config.TABLE_SPACING,
  backgroundColor: colorBackgroundTable,
  borderCollapse: "collapse",
  cellSpacing: "0",
  cellPadding: "0",
  fontFamily: "Arial",
  width: "580px",
  minWidth: "580px",
  maxWidth: "580px",
  whiteSpace: "nowrap",
};
const ImageWrapper = {
  position: "relative",
  width: widthImage,
  height: "83px",
  marginLeft: "15px",
  borderRight: ".5px solid #BDD7EF" ,
  paddingRight: "15px",
};
const imgLeft = {
  position: "absolute",
  width: widthImage,
  height: "83px",
  top: "0",
};
const imgLeftCenter = {
  position: "absolute",
  height: widthImage,
  width: widthImage,
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
};
const Image = {
  width: widthImage,
  height: "100%",
  margin: "auto",
  display: "block",
  marginTop: "25px"

};
const ImageObject = {
  width: widthImage,
  height: "100%",
  margin: "auto",
  display: "block",
  marginTop: "25px"
};
const TextWrapper = {
  borderSpacing: "0",
  fontFamily: "Arial",
  lineHeight: "normal",
  paddingLeft: "15px",
  paddingTop: "25px",
  paddingBottom: "0",
  paddingRight: "15px",
  borderRight: ".5px solid #BDD7EF",
  verticalAlign: "top",
};

const CellStyle = {
  padding: "0",
  lineHeight: "0",
}

const AdressWrapper = {
  display: "block",
  fontFamily: "Arial",
  lineHeight: "normal",
  verticalAlign: "top",
  paddingLeft: "15px",
  borderRight: ".5px solid #BDD7EF"

};
const UserName = {
  fontSize: "16px",
  margin: "0",
  fontWeight: "700",
  lineHeight: "normal",
  display: "inline-block",
  color: compagnyColorPrimary,
};

const Job = {
  fontSize: "13px",
  color: compagnyColorSecondary,
  fontWeight: "400",
  verticalAlign: "middle",
  margin: "0 0 15px 0",
};

const JobText = {
  display: "inline-block",
  marginRight:"4px",
}
const Link = {
  color: compagnyColorPrimary,
  fontWeight: "bold",
  fontSize: "15px",
};

const meetlawLink = {
  fontSize: "12px",
  lineHeight: "12px",
  fontWeight: "400",
  margin: "10px 0 0 0",
  textDecoration: "none",
  border: "1px solid " + compagnyColorSecondary,
  padding: "10px",
  width: "100%",
  textAlign: "center",
  display: "block",
  color: compagnyColorSecondary
}

const StandardURL = {
  fontSize: "12px",
  lineHeight: "12px",
  fontWeight: "700",
  margin: "0 0 10px 0",
  textUnderlineOffset: "4px",
};
const AdressContainer = {
  paddingBottom: "10px",
  lineHeight: "0"
}
const AdressContainer2 = {
  lineHeight: "0"
}

function constructImgUrl(client, ext) {
  if (ext) {
    return `https://files.myclientisrich.com/${client}/${imgName}.${ext}`;
  }
}

const SignatureFormatter = ({ user, message, typeImage }) => {

  useEffect(() => {
    document.title = `${compagnyName} | Signature`;
    const metaCharset = document.createElement('meta');
    metaCharset.setAttribute('charSet', 'utf-8');
    document.head.appendChild(metaCharset);
    return () => {
      document.head.removeChild(metaCharset);
    };
  }, [compagnyName]);


  let urlUploadsImg = "";
  if (user.urlImage === "" || user.urlImage === null) {
    urlUploadsImg = constructImgUrl(client, 'gif');
  }

  let positionImage = false;
  let positionLeft;
  if (message === true) {
    positionImage = ImageObject;
    positionLeft = imgLeftCenter
  } else {
    positionImage = Image;
    positionLeft = imgLeft
  }

  return (
    <div>
      <div className="wrapper-table" style={WrapperStyle}>
        <table className="signature" style={SignatureStyle}>
          <tbody>
            <tr>
              {/* LEFT SIDE EMAILS  */}
              <td className="image__wrapper" style={ImageWrapper}>
                {user.urlImage ? (
                  <a style={positionLeft} href={`https://${user.website}`} target="_blank" rel="noreferrer">
                    <img src={urlUploadsImg} style={positionImage} alt="logo" />
                  </a>
                ) : (
                  <a style={positionLeft} href={`https://${user.website}`} target="_blank" rel="noreferrer">
                    <img src={urlUploadsImg} style={positionImage} alt="logo" />
                  </a>
                )}
              </td>
              {/* RIGHT SIDE EMAILS  */}
              <td className="text__wrapper" style={TextWrapper}>
                <table cellPadding="0" cellSpacing="0" style={{ width: '100%', lineHeight:"0"}}>
                  <tbody>
                    <tr>
                      <td style={CellStyle}>
                        <p style={UserName}>
                          {user.firstname} {user.lastname}
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p style={Job}>
                          <span style={JobText}>{user.job}</span>
                          <Linkedin linkedin={user.linkedin} />
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p style={StandardURL}>
                          <a href={`https://${user.website}`} style={Link}>{user.website}</a>
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td style={CellStyle}>
                        {user.phone ? <Phone phone={user.phone} /> : null}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
              <td style={AdressWrapper}>
                {user.postalAdressTitle ? (
                  <table cellPadding="0" cellSpacing="0"  style={AdressContainer}>
                    <PostalAdress
                      title={user.postalAdressTitle}
                      adressStreet={user.postalAdressStreet}
                      adressCity={user.postalAdressCity}
                    />
                  </table>
                ) : null}
                {user.postalAdressTitle2 ? (
                  <table  cellPadding="0" cellSpacing="0"  style={AdressContainer2}>
                    <PostalAdress
                      title={user.postalAdressTitle2}
                      adressStreet={user.postalAdressStreet2}
                      adressCity={user.postalAdressCity2}
                    />
                  </table>
                ) : null}

                <table cellPadding="0" cellSpacing="0"  style={AdressContainer2}>
                  <tr><td>
                    <a href={`${user.meetlaw}`} target="_blank" rel="noreferrer" style={meetlawLink}>RDV en ligne</a>
                  </td></tr>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default SignatureFormatter;
